import { createReducer, on } from '@ngrx/store';
import * as UIActions from '../actions/ui.actions';
import { MenuType } from '../../../models/menuType.enum';

export const UIFeatureKey = 'UI';

export interface UIState {
  currentSelectedDate: Date;
  currentLocationId: number | null;
  currentMealId: number | null;
  currentMenuType: MenuType | null;
  currentLogoSrc: string;
  primaryDishColor: string;
  accentDishColor: string;
}

export const initialState: UIState = {
  currentSelectedDate: new Date(),
  currentLocationId: null,
  currentMealId: null,
  currentMenuType: null,
  currentLogoSrc: 'https://res.cloudinary.com/avi-foodsystems/image/upload/v1538601573/Dish_Logo-white.png',
  primaryDishColor: '#385F79',
  accentDishColor: '#506A23'
};

export const uiReducer = createReducer(
  initialState,
  on(UIActions.setCurrentLocationId, (state, action) => ({
    ...state,
    currentLocationId: action.locationId,
  })),
  on(UIActions.clearCurrentLocationId, (state) => ({
    ...state,
    currentLocationId: null,
  })),
  on(UIActions.setCurrentMealId, (state, action) => ({
    ...state,
    currentMealId: action.mealId,
  })),
  on(UIActions.clearCurrentMealId, (state) => ({
    ...state,
    currentMealId: null,
  })),
  on(UIActions.setCurrentSelectedDate, (state, action) => ({
    ...state,
    currentSelectedDate: action.date,
  })),
  on(UIActions.clearCurrentSelectedDate, (state) => ({
    ...state,
    currentSelectedDate: null,
  })),
  on(UIActions.setCurrentMenuType, (state, action) => ({
    ...state,
    currentMenuType: action.menuType,
  })),
  on(UIActions.setCurrentLogoSrc, (state, action) => ({
    ...state,
    currentLogoSrc: action.logoSrc,
  })),
  on(UIActions.clearCurrentMenuType, (state) => ({
    ...state,
    currentMenuType: null,
  })),
  on(UIActions.setPrimaryDishColor, (state, action) => ({
    ...state,
    primaryDishColor: action.color,
  })),
  on(UIActions.setAccentDishColor, (state, action) => ({
    ...state,
    accentDishColor: action.color,
  })),
);
